export default "__VITE_ASSET__CIcRwQVl__"